import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import enTranslations from './locales/en.json';
import taTranslations from './locales/ta.json';

// Tamil font configuration for proper rendering
const configureTamilFonts = () => {
  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Tamil:wght@300;400;500;600;700&display=swap');

    .tamil-text {
      font-family: 'Noto Sans Tamil', 'Lohit Tamil', 'Tamil MN', sans-serif;
      line-height: 1.6;
      letter-spacing: 0.02em;
    }

    .tamil-heading {
      font-family: 'Noto Sans Tamil', 'Lohit Tamil', 'Tamil MN', sans-serif;
      font-weight: 600;
      line-height: 1.4;
    }

    .tamil-ui {
      font-family: 'Noto Sans Tamil', 'Lohit Tamil', 'Tamil MN', system-ui, sans-serif;
      font-size: 0.95em;
      line-height: 1.5;
    }

    /* RTL support for Tamil */
    [dir="rtl"] .tamil-text,
    [dir="rtl"] .tamil-heading,
    [dir="rtl"] .tamil-ui {
      text-align: right;
      unicode-bidi: plaintext;
    }

    /* Mobile optimization for Tamil text */
    @media (max-width: 768px) {
      .tamil-text {
        font-size: 0.9em;
        line-height: 1.7;
      }

      .tamil-heading {
        font-size: 0.95em;
        line-height: 1.5;
      }
    }
  `;
  document.head.appendChild(style);
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'voterVerify_language',
    },

    resources: {
      en: {
        translation: enTranslations
      },
      ta: {
        translation: taTranslations
      }
    },

    react: {
      useSuspense: false,
    }
  });

// Initialize Tamil fonts when i18n is ready
i18n.on('initialized', () => {
  configureTamilFonts();
});

// Configure language-specific settings
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;

  // Set text direction for Tamil (can be adjusted based on user preference)
  if (lng === 'ta') {
    document.documentElement.dir = 'ltr'; // Tamil is typically written left-to-right
    document.body.classList.add('tamil-text');
  } else {
    document.documentElement.dir = 'ltr';
    document.body.classList.remove('tamil-text');
  }
});

export default i18n;